import { IState, ISpamPostsState } from 'types/redux'

export const getSpamPostsState = ({ spamPosts }: IState): ISpamPostsState => spamPosts

export const getSpamPostItems = ({ spamPosts }: IState): Array<any> => spamPosts.items

export const getSpamPostsLoading = ({ spamPosts }: IState): boolean => spamPosts.isLoading
